<template>
    <div class="gatewayPage">
        <LeftTree ref="treeLeft" @changeWay="changeWayFn" />
        <!-- <v-button :optareBtn="statusOPtareBtn" class="rightDropdown" @changeWayFn="changeWayFn"></v-button> -->
        <div style='width: calc(100% - 300px)'>
            <div class="device-status-desc">
                {{ $t(deviceStatusButton[sensorWay].title) }}
            </div>
            <div style="height: calc(100% - 50px);">
                <components :is="sensorWay" :sensorWay="sensorWay" :deviceGateWayType="deviceGateWayType"
                    ref="componentContent"></components>
            </div>
        </div>
        <i class="iconfont icon-excel question excel" :title="$t('integration.export_template')"
            v-show="sensorWay === 'unknown'" @click="loadFileFn"></i>
        <div class="question">
            <IconDesc :iconDesc="baseIconDesc"></IconDesc>
        </div>
        <BaseDetailDialog></BaseDetailDialog>
        <BindHistory></BindHistory>
    </div>
</template>

<script>
// 使用网关的组织架构树
import LeftTree from './components/leftTree.vue'
import IconDesc from '@/components/IconDesc/IconDesc'
import BindPage from './bind/bindPage.vue'
import unBindPage from './unbind/UnBindPage.vue'
import stopPage from './stop/stopPage.vue'
import unknowPage from './unknow/UnKnowPage.vue'
import bus from '@/utils/bus'
import { deviceStatusButton } from '@/utils/convert'
import BindHistory from '@/pages/equipment/base/components/BindHistory'
import BaseDetailDialog from '../../../components/dialog/baseDetail/baseDetailDialog.vue'
import baseIconDesc from './config/baseIconDesc'
import { getGeneraUploadTemplateFile } from '@/api/modules/deviceUrl'

export default {
  components: {
    LeftTree,
    bind: BindPage,
    unbind: unBindPage,
    stop: stopPage,
    unknown: unknowPage,
    IconDesc,
    BaseDetailDialog,
    BindHistory
  },
  computed: {
    deviceStatusButton: () => deviceStatusButton,
    /** 用于表示当前登录用户属于什么类型的角色 */
    sysAdmin () {
      const currentUser = this.$store.getters.userInfo.scope
      if (currentUser.sysScope && currentUser.sysAdmin) {
        // 系统管理员
        return 'isSysAdmin'
      } else if (currentUser.sysScope && !currentUser.sysAdmin) {
        // 系统非管理员
        return 'isSysNoAdmin'
      } else if ((!currentUser.sysScope && currentUser.scopeAdmin) || currentUser.type === 2) {
        // 非系统管理员 以及代理角色  代理角色是迭代7的需求添加
        return 'noSysIsAdmin'
      } else {
        // 非系统非管理员
        return 'noSysNoAdmin'
      }
    },
    baseIconDesc: () => baseIconDesc
  },
  data () {
    return {
      sensorWay: 'bind',
      deviceGateWayType: [],
      gatewayDetailShow: false
    }
  },

  mounted () {
    // if (this.sysAdmin === 'isSysNoAdmin' || this.sysAdmin === 'noSysNoAdmin') {
    //     this.statusOPtareBtn.pop();
    // }
  },
  methods: {
    loadFileFn () {
      getGeneraUploadTemplateFile('plinth', this.$i18n.locale).then(res => { })
    },
    changeWayFn (item) {
      this.$refs.treeLeft.filterText = null
      const { way } = item
      this.sensorWay = way
      // 重置左侧树形搜索条件
      if (way === 'unbind' || way === 'unknown') {
        this.$refs.componentContent.SearchForm.scopeId = this.$store.getters.SchemaTree[0].id
        this.$refs.componentContent.SearchForm.scopeName = this.$store.getters.SchemaTree[0].label
      } else {
        this.$refs.componentContent.SearchForm.scopeName = null
      }
      this.$refs.componentContent.SearchForm.sceneId = null

      //  this.$refs.componentContent.getListFn();
      /** 抛出一个方法修改树形结构数据 醉了 */
      bus.$emit('editTree', item)
    }
  }
}
</script>

<style lang="scss" scoped>
.gatewayPage {
    height: 100%;
    display: flex;
    position: relative;

    .rightDropdown {
        position: absolute;
        right: 15px;
        top: 0px;
    }

    .question {
        position: absolute;
        right: 15px;
        top: 67px;
        font-size: 18px;
        cursor: pointer;
        color: #9bccfd;

        &:hover {
            color: var(--primary-color);
        }
    }

    .excel {
        right: 40px;
    }
}

.rightPage {
    flex: 1;
    height: 100%;
    //padding: 0 15px;
    overflow: auto;
    //border-left: 1px solid $borderColor3;
    box-sizing: border-box;
}
</style>
